module.exports = __webpack_public_path__ + "img/2B5EYGT.7c4f9d76.jpg";